export enum VBKType {
  EPUB = "epub",
  PBK = "pbk",
}

interface Feature {
  name: string;
  status: number;
  partner_id: string;
  options: {};
}

// There are probably more, I don't know all the possible values
export enum IntendedUse {
  VST_STORE = "vst store",
  CODE_API = "code-api",
}

// There are many others
export enum Kind {
  SUBSCRIPTION = "subscription",
}

export interface BookInfo {
  title: string;
  author: string;
  vbkType: VBKType;
  isFixedLayout: boolean;
  dpsAvailable: false;
  hasPageBreaks: boolean;
  coverWidths: number[];
  coverURL: string;
  isbn: string;
  features: Feature[];
  hasAncillaries: boolean;
  copyLimit: number | null | undefined;
  ssoOnly: boolean;
  expiresAt: string;
  intendedUses: IntendedUse[];
  kind: Kind;
}
